import { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Space, Button } from "@masterteam/mt-design-react";

import Modal from "../../Modal";
import RequestActionModal from "../../RequestActionModal";
import FormHeader from "../../FormHeader";

import "./style.scss";

const initialActionModal = {
  isOpen: false,
  isApprove: false,
  isReturn: false,
  data: null,
};

function Header({
  canApprove,
  getData,
  data,
  isReadOnly,
  onSubmit,
  title = "add-initiative",
}) {
  const [actionModal, setActionModal] = useState(initialActionModal);

  if (!isReadOnly)
    return (
      <FormHeader
        handleSaveAsDraft={onSubmit}
        title={title}
        cancelRoute={"/"}
      />
    );

  return (
    <>
      <Space align="center" className="create-initiative-header">
        <Space className="create-initiative-header__title">
          <FormattedMessage id={title} />
        </Space>
        <Space align="center" className="create-initiative-header__actions">
          {canApprove ? (
            <>
              <Button
                variant="success"
                onClick={(e) => {
                  e.stopPropagation();
                  setActionModal({
                    isOpen: true,
                    isApprove: true,
                    data,
                  });
                }}
              >
                <FormattedMessage id="common.approve" />
              </Button>
              <Button
                variant="dark"
                onClick={(e) => {
                  e.stopPropagation();
                  setActionModal({
                    isOpen: true,
                    isApprove: false,
                    isReturn: true,
                    data,
                  });
                }}
              >
                <FormattedMessage id="common.return" />
              </Button>
              <Button
                variant="error"
                onClick={(e) => {
                  e.stopPropagation();
                  setActionModal({
                    isOpen: true,
                    isApprove: false,
                    data,
                  });
                }}
              >
                <FormattedMessage id="common.reject" />
              </Button>
            </>
          ) : null}
        </Space>
      </Space>
      {actionModal.isOpen ? (
        <Modal isOpen={actionModal.isOpen}>
          <RequestActionModal
            measureItem={actionModal?.data}
            callback={() => getData()}
            closeModal={() => setActionModal(initialActionModal)}
            isApprove={actionModal?.isApprove}
            isReturn={actionModal?.isReturn}
          />
        </Modal>
      ) : null}
    </>
  );
}

export default injectIntl(Header);
